import { Box, Button, Chip, Grid } from "@mui/material";
import { useContext, useState } from "react";
import { Global_CTX } from "../../contexts/global-ctx";
import {
    Organization_Service,
    Organization_Status,
} from "../../services/organization/organization-service";
import { Search } from "../filters/Search";
import New_Item from "../new-item";
import { RUDTable } from "../Table/RUDTable";
import Create_Org_Form from "./create-org-form";

const initial_filter = {
    search: "",
    apply: 0,
};

export default function Organizations_Page() {
    const { refetch_counter } = useContext(Global_CTX);
    const [filter, set_filter] = useState(initial_filter);

    return (
        <Box>
            <Box mb={2}>
                <New_Item title="Create Organization">
                    <Create_Org_Form />
                </New_Item>
            </Box>

            <Grid container p={2} gap={2}>
                <Grid item xs={12} lg={3}>
                    <Search filter={filter} setFilter={set_filter} />
                </Grid>

                <Grid item xs={12} lg={3}>
                    <Button
                        color="primary"
                        fullWidth
                        variant="contained"
                        onClick={() =>
                            set_filter({
                                ...filter,
                                apply: (filter.apply ?? 0) + 1,
                            })
                        }
                        style={{ height: "100%" }}
                        size="small"
                    >
                        {" "}
                        Search
                    </Button>
                </Grid>
            </Grid>

            <RUDTable
                storageKey="organizations-page"
                updatingAgents={[refetch_counter, filter.apply]}
                getter={() =>
                    Organization_Service.getInstance().get_orgs({
                        search: filter.search ? filter.search : undefined,
                    })
                }
                deletor={(id, row) => {
                    return Organization_Service.getInstance().delete_org(
                        row.code
                    );
                }}
                editor={(id, updated_org) => {
                    return Organization_Service.getInstance().update_org(
                        id,
                        updated_org
                    );
                }}
                rowsPreprocessor={(row) => ({
                    ...row,
                    id: row.code,
                    deletionId: row.code,
                    default_status: { id: row.status },
                    status: (
                        <Chip
                            variant="outlined"
                            size="small"
                            label={
                                row.status === "suspended"
                                    ? "Suspended"
                                    : "Active"
                            }
                            color={
                                row.status === "suspended"
                                    ? "warning"
                                    : "success"
                            }
                        />
                    ),
                })}
                ops={{
                    read: "",
                    // edit: undefined,
                    // delete: undefined,
                }}
                readables={{
                    name: "Name",
                    code: "Organization Code",
                    status: "Status",
                }}
                editables={[
                    {
                        isRequired: true,
                        label: "Name",
                        name: "name",
                        type: "textfield",
                    },
                    {
                        isRequired: true,
                        label: "Organization Code",
                        name: "code",
                        type: "textfield",
                    },
                    {
                        name: "status",
                        type: "autocomplete",
                        label: "Status",
                        autocomplete: {
                            labelKey: "label",
                            label: "Status",
                            defaultOptions: Object.entries(
                                Organization_Status
                            ).map(([label, id]) => ({ label, id })),
                            defaultValue: "default_status",
                        },
                    },
                ]}
            />
        </Box>
    );
}
